var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-sheet",
    {
      ref: "dzone",
      staticClass: "dropzone pa-2",
      class: { dragover: _vm.dragover },
      staticStyle: { cursor: "pointer" },
      attrs: {
        id: "dropzone",
        tabindex: "0",
        title: "Klicka här för att ladda upp en fil!",
        color: _vm.dragover ? "red lighten-4" : "indigo lighten-4",
        width: "100%",
        height: "200",
      },
    },
    [
      _c("input", {
        ref: "upload",
        staticStyle: { display: "none" },
        attrs: { id: "fileUpload", type: "file", accept: "text/xml" },
      }),
      _vm._v(" "),
      _c("v-row", { staticClass: "pt-5", attrs: { justify: "center" } }, [
        _c("span", { staticClass: "title indigo--text text--darken-2" }, [
          _vm._v("Ladda upp en SIE-fil för test genom att släppa den här!"),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "pt-5", attrs: { justify: "center" } },
        [
          _c("v-icon", { attrs: { color: "indigo darken-2", size: "75" } }, [
            _vm._v("mdi-cloud-upload-outline"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }